import InsurancePoliciesView from './InsurancePolicies'

export default InsurancePoliciesView
